/** @jsx jsx */
import { jsx } from 'theme-ui'
import { number, string } from 'prop-types'

const Menu = ({ color, height = 14, ...props }) => {
  return (
    <svg
      width={20}
      height={height}
      viewBox="0 0 20 14"
      sx={{ fill: color }}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 14h20v-2H0v2zm0-6h20V6H0v2zm0-6h20V0H0v2z"
        fill="#fff"
      />
    </svg>
  )
}

Menu.propTypes = {
  color: string,
  height: number,
}

export default Menu
